import { render } from "./IsActiveComponentV1.vue?vue&type=template&id=4f45d4e2&scoped=true"
import script from "./IsActiveComponentV1.vue?vue&type=script&lang=js"
export * from "./IsActiveComponentV1.vue?vue&type=script&lang=js"

import "./IsActiveComponentV1.vue?vue&type=style&index=0&id=4f45d4e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f45d4e2"]])

export default __exports__